import { useState, useEffect, useRef } from 'react';
import { ArrowDropDown, ArrowDropUp, Close } from '@mui/icons-material';
import { Range as ReactRange, getTrackBackground } from 'react-range';

import '../Dropdown/Dropdown.css';
import './Range.css';

function Range(
    {setRangeValue, min, max, step=0.05, placeholder="Select"} :
    {setRangeValue: any, min: number|Promise<number>, max: number|Promise<number>, step?: number, placeholder: string}
)
{
    let [value, setValue] = useState<{label:string, minValue:number, maxValue:number}>({label: placeholder, minValue: typeof min === 'number' ? min : 0, maxValue: typeof max === 'number' ? max : 100});
    let [ends, setEnds] = useState<{min:number, max:number}>({min: typeof min === 'number' ? min : -1, max: typeof max === 'number' ? max : -1});
    let dropdownRef = useRef<HTMLDivElement>(null);
    let [open, setOpen] = useState(false);

    const handleClick = (e:any) => {
        if (e.target !== dropdownRef.current && !dropdownRef.current?.contains(e.target)) {
            setOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClick);

        return () => document.removeEventListener('click', handleClick);
    })

    useEffect(() => {
        // Set bounds via promise
        if (typeof min === 'number' && typeof max === 'number') {
            setValue({label: placeholder, minValue: min, maxValue: max});
        } else if (typeof min !== 'number' && typeof max !== 'number') {
            min.then(min => {
                max.then(max => {
                    let roundMin = Math.floor(min * 20) / 20;
                    let roundMax = Math.ceil(max * 20) / 20;
                    setEnds({min: roundMin, max: roundMax});
                    setValue({label: placeholder, minValue: roundMin, maxValue: roundMax});
                })})
        }
    }, [min, max, placeholder])

    const setValues = (values:Array<number>) => {
        setValue({label: value.label, minValue: values[0], maxValue: values[1]});
        setRangeValue(values)
    }
    let modified = value.minValue !== ends.min || value.maxValue !== ends.max;

    return (
        <div ref={dropdownRef} className={open ? "dropdown open" : "dropdown"} onClick={() => setOpen(!open)} >
            <div className="dropdownInitial">
                {value.label} {ends.min === ends.max ? `(${ends.min})` : modified ? value.minValue === value.maxValue ? `(${value.minValue})` : `(${value.minValue} - ${value.maxValue})` : null}
                {open ? <ArrowDropUp /> : <ArrowDropDown />}
            </div>
            <div className="options" onClick={(e) => e.stopPropagation()}>
                <h3 className="mobile">{placeholder}</h3>
                <div className="btn mobile" onClick={() => setOpen(false)}>
                    <Close />
                    <span>Close</span>
                </div>
                <span>
                    {ends.min === ends.max ?
                        `All items have the same value for this range.` :
                        "Anything between the two sliders will be included in your search."
                    }
                </span>
                {(ends.min !== -1 && ends.max !== -1) && <div className="rangeBody">
                    {ends.min !== ends.max && <>
                        <input type="number" className={value.minValue !== ends.min ? 'modified' : undefined} min={ends.min} max={ends.max} onChange={(e) => setValues([Math.min(Math.max(parseFloat(e.target.value), ends.min), value.maxValue), value.maxValue])} value={value.minValue} maxLength={3} />
                        <ReactRange
                            min={ends.min}
                            max={ends.max}
                            step={step}
                            values={[value.minValue, value.maxValue]}
                            onChange={setValues}
                            renderTrack={({ props, children }) => (
                                <div
                                    onMouseDown={props.onMouseDown}
                                    onTouchStart={props.onTouchStart}
                                    className="rangeSlider"
                                    style={{
                                        ...props.style,
                                        height: "36px",
                                        display: "flex",
                                        width: "100%"
                                    }}
                                >
                                    <div
                                        ref={props.ref}
                                        style={{
                                        height: "5px",
                                        width: "100%",
                                        borderRadius: "4px",
                                        background: getTrackBackground({
                                            values: [value.minValue, value.maxValue],
                                            colors: ["#959595", "var(--primary)", "#959595"],
                                            min: ends.min,
                                            max: ends.max
                                        }),
                                        alignSelf: "center"
                                        }}
                                    >
                                        {children}
                                    </div>
                                </div>
                            )}
                            renderThumb={({ props }) => (
                                <div
                                    {...props}
                                    style={{
                                    ...props.style,
                                    height: '20px',
                                    width: '10px',
                                    backgroundColor: 'var(--primary)'
                                    }}
                                />
                            )}
                        />
                        <input type="number" className={value.maxValue !== ends.max ? 'modified' : undefined} onChange={(e) => setValues([value.minValue, Math.max(Math.min(parseFloat(e.target.value), ends.max), value.minValue)])} min={ends.min} max={ends.max} value={value.maxValue} maxLength={3} />
                    </>}
                </div>}
                <div className="btn dangerBtn" style={
                    {
                        height: modified ? undefined : '0',
                        overflow: 'hidden',
                        padding: modified ? undefined : '0',
                        borderWidth: modified ? undefined : '0',
                        transition: 'height 0.2s ease-in-out, padding 0.05s ease-in-out, border-width 0.03s ease-in-out, border-color 0.2s ease-in-out',
                    }} onClick={() => setValues([ends.min as number, ends.max as number])}>
                    <Close /> Reset
                </div>
            </div>
        </div>
    )
}

export default Range;